/** 控制台 · 渠道后台（pages/console/reseller.tsx，docs/12）。 */
const messages = {
  'page.title': '渠道后台',
  'page.description':
    '{name} · 客户通过你的推广链接注册后归属到你。客户的每笔消费按约定折扣计提分成，平台定期结算给你。',
  'status.suspended': '合作已暂停：新注册的用户不会归属到你，客户的新消费暂不计提分成。如有疑问请联系平台。',
  'status.closed': '合作已结束：推广链接已失效，不再计提新的分成；历史数据仍可查看。',

  copy: '复制',
  copied: '已复制',
  copyAria: '复制{label}',
  zhe: '{zhe} 折',
  'summary.code': '推广码',
  'summary.link': '推广链接',
  'summary.linkHint': '把链接发给客户，通过链接注册的账号自动归属到你。',
  'summary.discount': '默认 {zhe} 拿货，分成 {share}%',
  'summary.modelDiscount': '{model}：{zhe}（分成 {share}%）',
  'summary.customers': '客户',
  'summary.customers30': '近 30 天新增 {n}',
  'summary.accrued': '待结算分成 · {currency}',
  'summary.settled': '已结算分成 · {currency}',
  'summary.loadError': '渠道信息加载失败',

  'months.title': '月度对账',
  'months.description': '按自然月汇总客户消费、批发价与分成（已扣除退款冲回）。',
  'months.month': '月份',
  'months.charged': '客户消费',
  'months.wholesale': '批发价',
  'months.amount': '分成',
  'months.tasks': '任务数',
  'months.export': '导出',
  'months.exportAria': '导出 {month} 消费明细（CSV）',

  'tab.customers': '客户',
  'tab.usage': '消费明细',
  'tab.settlements': '结算记录',

  'customers.search': '搜索客户邮箱',
  'customers.empty': '还没有客户。把推广链接发给客户，对方注册后会出现在这里。',
  'customers.emptySearch': '没有匹配的客户。',
  'customers.loadError': '客户列表加载失败',
  'customers.email': '客户',
  'customers.registered': '注册时间',
  'customers.available': '可用额度',
  'customers.total': '累计消费',
  'customers.charged30': '近 30 天消费',
  'customers.tasks30': '{n} 个任务',
  'customers.last': '最近任务',
  'customers.unverified': '邮箱未验证',

  'usage.month': '月份',
  'usage.allMonths': '全部月份',
  'usage.empty': '还没有消费记录。客户的任务结算后，每笔消费与分成会出现在这里。',
  'usage.loadError': '消费明细加载失败',
  'usage.time': '时间',
  'usage.customer': '客户',
  'usage.model': '模型',
  'usage.charged': '客户消费',
  'usage.wholesale': '批发价',
  'usage.amount': '分成',
  'usage.status': '状态',
  'usage.clawback': '退款冲回',
  'usage.export': '导出 CSV',

  'settlements.empty': '还没有结算记录。',
  'settlements.loadError': '结算记录加载失败',
  'settlements.time': '结算时间',
  'settlements.amount': '金额',
  'settlements.count': '笔数',
  'settlements.method': '方式',
  'settlements.offline': '线下打款',
  'settlements.quota': '计入账号额度',
  'settlements.ref': '转账单号',
  'settlements.note': '备注',

  'list.loaded': '第 {page} 页 · 本页 {n} 条',
  'list.loading': '正在加载…',
};

export default messages;
